// Selectors
import { selectAppSlugByPath } from '../../reducers/agency/agencySelectors';

const getFirstTrimmedValue = (...values) => {
  for (const value of values) {
    if (typeof value === 'string' || typeof value === 'number') {
      const trimmedValue = String(value).trim();
      if (trimmedValue) {
        return trimmedValue;
      }
    }
  }

  return '';
};

const normalizePaymentMailingAddress = address => {
  if (!address || typeof address !== 'object') {
    return null;
  }

  const zipCandidates = [
    address.zipFive,
    address.zipCode,
    address.postalCode,
  ].map(value => getFirstTrimmedValue(value).replace(/\D/g, ''));
  const zip = zipCandidates.find(Boolean) || '';
  const zipFour =
    getFirstTrimmedValue(address.zipFour)
      .replace(/\D/g, '')
      .slice(0, 4) ||
    zipCandidates.find(value => value.length >= 9)?.slice(5, 9) ||
    '';

  const normalizedAddress = {
    streetAddress: getFirstTrimmedValue(
      address.streetAddress,
      address.addressLine1,
      address.address1
    ),
    streetAddress2: getFirstTrimmedValue(
      address.addressLine2,
      address.address2
    ),
    city: getFirstTrimmedValue(address.city),
    state: getFirstTrimmedValue(
      address.state?.value,
      address.state?.code,
      address.state,
      address.stateCd?.value,
      address.stateCd?.code,
      address.stateCd,
      address.stateProvince?.value,
      address.stateProvince?.code,
      address.stateProvince
    ),
    zip: zip.slice(0, 5),
    zipFour,
  };

  return Object.values(normalizedAddress).some(Boolean)
    ? normalizedAddress
    : null;
};

export const getPaymentMailingAddress = state => {
  const appSlug = selectAppSlugByPath(state);
  let agencyAddresses = [];

  if (appSlug === 'dmvrr') {
    agencyAddresses = [state.dmv?.appProfile?.mailingAddress];
  } else if (appSlug === 'dpslr') {
    agencyAddresses = [
      state.dps?.renewalMailingAddress,
      state.dps?.renewalHomeAddress,
      // No address change in the renewal flow: use the account settings address
      state.user?.addresses?.mailing,
    ];
  } else if (appSlug === 'tpwdas') {
    agencyAddresses = [
      state.tpwd?.selected?.link?.profile?.account?.[0]?.primaryOwnerAddress,
    ];
  } else if (appSlug === 'tdlrlr') {
    agencyAddresses = [state.tdlr?.appProfile?.info.values.address];
  } else {
    agencyAddresses = [state.user?.addresses?.mailing];
  }

  return (
    agencyAddresses
      .map(normalizePaymentMailingAddress)
      .find(
        address =>
          address?.streetAddress && address.city && address.state && address.zip
      ) || null
  );
};